const HOSTNAME =
	window.location.hostname.indexOf('dev.cirma.org.gt') >= 0
		? window.location.hostname.replace(
				'dev.cirma.org.gt',
				'api.dev.cirma.org.gt'
		  )
		: //.replace('.cliente', '')
		window.location.hostname.indexOf('local') >= 0
		? 'api.dev.cirma.local'
		: 'api.cirma.org.gt';
export const BACKEND_URL = window.location.protocol + '//' + HOSTNAME;
//console.log(BACKEND_URL);
export const DRUPAL_URL = `${BACKEND_URL}/glifos`;
export const DRUPAL_URI_ARTICLES = '/jsonapi/node/noticia';
export const DRUPAL_URI_EVENTS = '/jsonapi/node/evento';
export const DRUPAL_URI_COLLECTIONS = '/jsonapi/node/colecciones';
export const DRUPAL_URI_PROJECTS = '/jsonapi/node/proyecto';
export const DRUPAL_URI_CLUBS = '/jsonapi/node/club';
export const DRUPAL_URI_CONOCIENDO = '/jsonapi/node/conociendo_cirma';
export const DRUPAL_URI_TRIBUTES = '/jsonapi/node/homenaje';
export const DRUPAL_URI_DONORS = '/jsonapi/node/donante_y_donacion';
export const DRUPAL_URI_SPECIAL = '/jsonapi/node/especial';
export const DRUPAL_HEADERS = {
	Accept: 'application/vnd.api+json',
};

export const YII_URL = `${BACKEND_URL}/v1/`;

export const MONTHS = [
	'Enero',
	'Febrero',
	'Marzo',
	'Abril',
	'Mayo',
	'Junio',
	'Julio',
	'Agosto',
	'Septiembre',
	'Octubre',
	'Noviembre',
	'Diciembre',
];

export const ISADG_METADATA = [
	{
		label: 'Área de Identificación',
		field: 'identificacion',
		children: [
			{
				label: 'Código de Referencia',
				field: 'codigo_referencia',
			},
			{
				label: 'Título',
				field: 'titulo',
			},
			{
				label: 'Fecha(s)',
				field: 'fecha',
				multiple: true,
			},
			{
				label: 'Nivel de Descripción',
				field: 'nivel_descripcion',
			},
			{
				label: 'Volumen y soporte de la unidad de descripción',
				field: 'extent',
				multiple: true,
			},
		],
	},
	{
		label: 'Área de Contexto',
		field: 'contexto',
		children: [
			{
				label: 'Nombre del o de los productor(es)',
				field: 'productor',
				multiple: true,
			},
			{
				label: 'Autor(es)',
				field: 'autor',
				multiple: true,
			},
			{
				label: 'Historia institucional',
				field: 'historia_institucional',
			},
			{
				label: 'Historia archivística',
				field: 'historia_archivistica',
			},
			{
				label: 'Forma de Ingreso',
				field: 'ingreso',
			},
		],
	},
	{
		label: 'Área de Contenido y Estructura',
		field: 'contenido_estructura',
		children: [
			{
				label: 'Alcance y Contenido',
				field: 'alcance_contenido',
			},
			{
				label: 'Valoración, selección y eliminación',
				field: 'valoracion',
			},
			{
				label: 'Nuevos ingresos',
				field: 'ingresos',
			},
			{
				label: 'Organización',
				field: 'organizacion',
			},
		],
	},
	{
		label: 'Área de Condiciones de Acceso y Uso',
		field: 'condiciones_acceso',
		children: [
			{
				label: 'Condiciones de acceso',
				field: 'acceso',
			},
			{
				label: 'Condiciones de reproducción',
				field: 'reproduccion',
			},
			{
				label: 'Lengua/escritura(s) de la documentación',
				field: 'lengua_escritura',
				multiple: true,
			},
			{
				label: 'Características físicas y requisitos técnicos',
				field: 'caracteristicas',
			},
			{
				label: 'Instrumentos de descripción',
				field: 'instrumentos',
				multiple: true,
			},
		],
	},
	{
		label: 'Área de Documentación Asociada',
		field: 'documentacion_asociada',
		children: [
			{
				label: 'Existencia y localización de los originales',
				field: 'localizacion_original',
			},
			{
				label: 'Existencia y localización de las copias',
				field: 'localizacion_copia',
			},
			{
				label: 'Unidades de descripción relacionadas',
				field: 'unidades_relacionadas',
				multiple: true,
				link: true,
			},
			{
				label: 'Notas de publicaciones',
				field: 'notas_publicaciones',
			},
		],
	},
	{
		label: 'Área de Notas',
		field: 'notas',
		children: [
			{
				label: 'Notas',
				field: 'nota',
			},
		],
	},
	/* {
		label: 'Área de Control de Descripción',
		field: 'control',
		children: [
			{
				label: 'Nota del archivero',
				field: 'nota_archivero',
			},
			{
				label: 'Reglas o normas',
				field: 'normas',
			},
			{
				label: 'Fecha(s) de la(s) descripción(es)',
				field: 'fecha_descripcion',
				multiple: true,
			},
		],
	}, */
];

export const ISADG_METADATA_RESUME = [
	{
		label: 'Área de Identificación',
		field: 'identificacion',
		children: [
			{
				label: 'Código de Referencia',
				field: 'codigo_referencia',
			},
			{
				label: 'Título',
				field: 'titulo',
			},
			{
				label: 'Fecha(s)',
				field: 'fecha',
				multiple: true,
			},
			{
				label: 'Nivel de Descripción',
				field: 'nivel_descripcion',
			},
			{
				label: 'Volumen y soporte de la unidad de descripción',
				field: 'extent',
				multiple: true,
			},
		],
	},
	{
		label: 'Área de Contexto',
		field: 'contexto',
		children: [
			{
				label: 'Nombre del o de los productor(es)',
				field: 'productor',
				multiple: true,
			},
			{
				label: 'Autor(es)',
				field: 'autor',
				multiple: true,
			},
			{
				label: 'Historia institucional',
				field: 'historia_institucional',
			},
			{
				label: 'Historia archivística',
				field: 'historia_archivistica',
			},
			{
				label: 'Forma de Ingreso',
				field: 'ingreso',
			},
		],
	},
	{
		label: 'Área de Contenido y Estructura',
		field: 'contenido_estructura',
		children: [
			{
				label: 'Alcance y Contenido',
				field: 'alcance_contenido',
			},
			{
				label: 'Valoración, selección y eliminación',
				field: 'valoracion',
			},
			{
				label: 'Nuevos ingresos',
				field: 'ingresos',
			},
			{
				label: 'Organización',
				field: 'organizacion',
			},
		],
	},
	/* {
		label: 'Área de Condiciones de Acceso y Uso',
		field: 'condiciones_acceso',
		children: [
			{
				label: 'Condiciones de acceso',
				field: 'acceso',
			},
			{
				label: 'Condiciones de reproducción',
				field: 'reproduccion',
			},
			{
				label: 'Lengua/escritura(s) de la documentación',
				field: 'lengua_escritura',
				multiple: true,
			},
			{
				label: 'Características físicas y requisitos técnicos',
				field: 'caracteristicas',
			},
			{
				label: 'Instrumentos de descripción',
				field: 'instrumentos',
				multiple: true,
			},
		],
	},
	{
		label: 'Área de Documentación Asociada',
		field: 'documentacion_asociada',
		children: [
			{
				label: 'Existencia y localización de los originales',
				field: 'localizacion_original',
			},
			{
				label: 'Existencia y localización de las copias',
				field: 'localizacion_copia',
			},
			{
				label: 'Unidades de descripción relacionadas',
				field: 'unidades_relacionadas',
				multiple: true,
				link: true,
			},
			{
				label: 'Notas de publicaciones',
				field: 'notas_publicaciones',
			},
		],
	},
	{
		label: 'Área de Notas',
		field: 'notas',
		children: [
			{
				label: 'Notas',
				field: 'nota',
			},
		],
	}, */
	/* {
		label: 'Área de Control de Descripción',
		field: 'control',
		children: [
			{
				label: 'Nota del archivero',
				field: 'nota_archivero',
			},
			{
				label: 'Reglas o normas',
				field: 'normas',
			},
			{
				label: 'Fecha(s) de la(s) descripción(es)',
				field: 'fecha_descripcion',
				multiple: true,
			},
		],
	}, */
];

export const ISADG_LEVELS = {
	fond: {
		value: 'fond',
		label: 'Fondo',
		showInTree: true,
	},
	'sub-fond': {
		value: 'sub-fond',
		label: 'Subfondo',
		showInTree: true,
	},
	seccion: {
		value: 'seccion',
		label: 'Sección',
		showInTree: true,
	},
	'sub-sec': {
		value: 'sub-sec',
		label: 'Subsección',
		showInTree: true,
	},
	serie: {
		value: 'serie',
		label: 'Serie',
		showInTree: true,
	},
	'sub-serie': {
		value: 'sub-serie',
		label: 'Subserie',
		showInTree: true,
	},
	file: {
		value: 'file',
		label: 'Expediente',
	},
	item: {
		value: 'item',
		label: 'Unidad Documental Simple',
	},
};
